export const PAGE_MODULES = Object.freeze({
  ALGOLIA_CARDS: "algolia-cards",
  HERO: "heroes",
  CATEGORY_COLLECTIONS: "category-collections",
  MODULE_MENU: "module-menu",
  CATEGORY_ROW: "category-rows",
  CATEGORY_HEROES: "category-heroes",
  MODULE_SLIDER: "module-slider",
});

export const NON_RENDER_COUNT_MODULES = Object.freeze(
  new Set([PAGE_MODULES.HERO, PAGE_MODULES.MODULE_MENU, PAGE_MODULES.CATEGORY_HEROES]),
);
